import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/pro-solid-svg-icons';
import { mobileMQ, smallMobileMQ } from '../../modules/theme';
import { initialState, getInitialTo } from '../../modules/app-duck';

const DateInput = props => {
  return (
    <input
      css={{
        borderRadius: 3,
        maxWidth: 135,
        // Overriding frogs global styles for inputs
        backgroundColor: 'rgba(255,255,255,0.15) !important',
        height: '28px !important',
        fontSize: '14px !important',
        padding: '0 0 0 5px !important',
        color: 'white !important',
        border: 'none !important',
        margin: '0 !important',
        [mobileMQ]: {
          maxWidth: 115,
        },
        [smallMobileMQ]: {
          height: '100%',
        },
      }}
      {...props}
    />
  );
};

export default function DatePicker({ setTo, setFrom, from, to, tab }) {
  const initialTo = getInitialTo(tab);
  return (
    <div css={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
      <div
        css={{
          background: 'rgba(22,34,83,0.8)',
          borderRadius: 3,
          display: 'flex',
          padding: 5,
          alignItems: 'center',
          marginRight: 10,
          [mobileMQ]: {
            padding: 2,
          },
          [smallMobileMQ]: {
            height: 40,
          },
        }}
      >
        <DateInput
          onChange={e => {
            setFrom(e.target.value);
          }}
          value={from}
          pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
          type="date"
          max={to}
        />
        <span css={{ color: 'white', margin: '0 5px', lineHeight: '1' }}>
          -
        </span>
        <DateInput
          onChange={e => {
            setTo(e.target.value);
          }}
          value={to}
          min={from}
          max={initialTo}
          pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
          type="date"
        />
      </div>
      {(initialState.from !== from || initialTo !== to) && (
        <button
          onClick={() => {
            setTo();
            setFrom();
          }}
          css={{
            border: 'none',
            width: 20,
            height: 20,
            borderRadius: '2px',
            color: 'white',
            cursor: 'pointer',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            [mobileMQ]: {
              height: 28,
              width: 28,
            },
          }}
        >
          <FontAwesomeIcon icon={faRedo} />
        </button>
      )}
    </div>
  );
}
